import { useHistory, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import {
  TeacherGetQuizByIdQuery,
  useDeleteQuizQuestionWithAllRelationsMutation,
} from '@school_ify/schoolify-repository/src/teacher/types';

import { ReactComponent as Edit } from 'assets/icons/edit.svg';
import { ReactComponent as BinTrash } from 'assets/icons/trash.svg';
import { QuizQuestionsNamesForType } from 'types/quiz/static';

import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import './QuestionsTable.scoped.scss';

interface QuestionsTableProps {
  questions: TeacherGetQuizByIdQuery['assignments_by_pk']['assignment_questions'];
  refetchQuiz: () => void;
}

interface ParamsProps {
  quizId: string;
}

const QuestionsTable = (props: QuestionsTableProps) => {
  const { quizId } = useParams<ParamsProps>();
  const { questions, refetchQuiz } = props;
  const history = useHistory();
  const { t } = useTranslation();

  const [deleteQuestion] = useDeleteQuizQuestionWithAllRelationsMutation();

  const handleDeleteQuestion = id => {
    deleteQuestion({
      variables: {
        id,
      },
      onCompleted: refetchQuiz,
    });
  };

  const handleEditQuestion = (questionId, questionType) => {
    history.push(`/quiz/questions/edit/${questionType}/${questionId}/${quizId}`);
  };

  return (
    <div className="question-table">
      <table>
        <tr>
          <th>{t('quiz:QuestionNumber')}</th>
          <th>{t('quiz:QuestionTitle')}</th>
          <th>{t('quiz:QustionType')}</th>
          <th>{t('quiz:Actions')}</th>
        </tr>
        {questions.map((question, index) => {
          const { title, type, id } = question;
          return (
            <tr key={index}>
              <td>
                <p>{index + 1}</p>
              </td>
              <td>
                <p>{title.replaceAll('<answer>', '________').replaceAll('&nbsp;', ' ')}</p>
              </td>
              <td>
                <p>{QuizQuestionsNamesForType[type]}</p>
              </td>
              <td>
                <div className="icons">
                  <Edit
                    color="#213960"
                    onClick={() => handleEditQuestion(id, type)}
                    height={16}
                    width={16}
                  />
                  <BinTrash
                    color="#213960"
                    onClick={() => handleDeleteQuestion(id)}
                    height={16}
                    width={16}
                  />
                </div>
              </td>
            </tr>
          );
        })}
      </table>
    </div>
  );
};

export default QuestionsTable;
